export default "__VITE_ASSET__WdHM1xn$__"